import { ProgressSpinner } from 'primereact/progressspinner';
import React, { Component } from 'react';

export function CenterLoader() {
  return (
    <div className="spinner-wrap-center">
      <ProgressSpinner animationDuration=".8s" />
    </div>
  );
}

class Loader extends Component {
  // componentDidMount() {
  //   document.body.classList.add('overflow-h');
  // }

  // componentWillUnmount() {
  //   document.body.classList.remove('overflow-h');
  // }

  render() {
    return (
      <div className="spinner-wrap" style={{ zIndex: 9999 }}>
        <ProgressSpinner animationDuration=".8s" />
      </div>
    );
  }
}

export default Loader;
